import { Button, message } from "antd";
import { useState } from "react";
import { useSelector } from "react-redux";
import { selectUserRoles } from "redux/slices/userSlice";
import K from "utilities/constants";
import { isPermissionPresent } from "utilities/generalUtility";
import { useIsAssignedToJob } from "features/candidates/hooks/useIsAssignedToJob";
import DeleteCandidateModal from "./deleteCandidateModal";
import Candidate from "redux/models/candidate";

export default function DeleteCandidateButton({
  candidateActivity,
  jobDetails,
  styles,
  disabled,
  onSuccess,
}) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const userRoles = useSelector(selectUserRoles);
  const isAssignedToJob = useIsAssignedToJob(jobDetails);

  const canDelete =
    isPermissionPresent(K.Permissions.DeleteCandidate, userRoles) &&
    isAssignedToJob;

  const onDelete = async () => {
    try {
      setLoading(true);

      await Candidate.deleteCandiate(candidateActivity.id);

      setOpen(false);
      onSuccess?.(candidateActivity.id);
      message.success("Candidate deleted successfully");
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  if (!canDelete) return null;

  return (
    <>
      <Button
        className={styles.deleteBtn}
        type="link"
        icon={<i className="icon-del-threshold" />}
        disabled={disabled || candidateActivity.isConsiderable === 0}
        onClick={() => setOpen(true)}
      />

      {open && (
        <DeleteCandidateModal
          candidateActivity={candidateActivity}
          open={open}
          loading={loading}
          onCancel={() => setOpen(false)}
          onDelete={onDelete}
        />
      )}
    </>
  );
}
